import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import Filters from "./Table/Filters";
import columns from "./Table/columns";
import data from "./Table/data";

import { useTopicContext } from "../../../contexts/TopicContext";

export default function Table() {
  const { dispatch, actions, state } = useTopicContext();

  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    actions.loadTopics(dispatch);
  }, []);

  return (
    <>
      <Filters keyword={keyword} setKeyword={setKeyword} />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={data(state.topics, keyword) || []}
          noDataComponent={
            <div className="mt20">
              {state.topics == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
